// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3XUHs","cell":"ColumnAccessor_cell__2pH89","firstCellAccent":"ColumnAccessor_firstCellAccent__2coZU"};